import { type ToastOptions, toast } from 'react-toastify';

const defaultToastOptions: ToastOptions = {
  draggable: false,
  position: 'bottom-right',
};

export function showErrorToast(content: string, options?: ToastOptions) {
  toast.error(content, {
    ...defaultToastOptions,
    ...options,
  });
}

export function showSuccessToast(content: string, options?: ToastOptions) {
  toast.success(content, {
    ...defaultToastOptions,
    ...options,
  });
}

export function showInfoToast(content: string, options?: ToastOptions) {
  toast.info(content, {
    ...defaultToastOptions,
    ...options,
  });
}

export function showWarningToast(content: string, options?: ToastOptions) {
  toast.warning(content, {
    ...defaultToastOptions,
    ...options,
  });
}
